import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from "@reduxjs/toolkit/query/react";

export const KupongApiService = createApi({
  reducerPath: "kuponApi",
  baseQuery: fetchBaseQuery({ baseUrl: `${baseURL}` }), // Base URL for v1 API
  endpoints: (builder) => ({
    getApplyKupong: builder.mutation({
      query: (body) => ({
        url: "/kupong/applyKupong",
        method: "POST",
        body, // Pass the request body here
      }),
    }),
    applyCoupon: builder.mutation({
      query: (body) => ({
        url: "/coupons/apply",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          console.log('Coupon applied successfully:', data);
        } catch (error) {
          console.error('Error applying coupon:', error);
        }
      },
    }),
  }),
});

export const { useGetApplyKupongMutation, useApplyCouponMutation } = KupongApiService;